import { StatReportFormData } from '@modules/statistics/StatCollection/StatCollection/AddEditStatFormTab/PreviewFormPage/PreviewFormPage';
import { Endpoint } from '../endpoint';
import { ReportResponse, ReportId, StatBatchId, CompactStatBatchResponse, StatBatchResponse } from '@business/entities/reports';
import { FCFormDataType } from '@modules/statistics/StatCollection/FormFields/types';

export function fetchBatches() {
  return Endpoint.get<CompactStatBatchResponse[]>(`@makh/stat-report/batches`);
}

export function fetchBatch(id: StatBatchId) {
  return Endpoint.get<StatBatchResponse>(`@makh/stat-report/batch/${id}`);
}

export function fetchReports() {
  return Endpoint.get<ReportResponse[]>(`@makh/stat-report`);
}

export function fetchReport(id: ReportId, isPublic = false) {
  if (isPublic) {
    return Endpoint.get<ReportResponse>(`@makh/public/stat-report/stat-report/${id}`);
  }
  return Endpoint.get<ReportResponse>(`@makh/stat-report/stat-report/${id}`);
}

export function createReport(stat: Partial<ReportResponse>) {
  return Endpoint.post<ReportResponse>(`@makh/stat-report/create`, { data: { ...stat } });
}

export function updateReport(id: ReportId, stat: Partial<ReportResponse>) {
  return Endpoint.patch<ReportResponse>(`@makh/stat-report/${id}`, { data: { ...stat } });
}

export function deleteReport(reportId: ReportId) {
  return Endpoint.delete<void>(`@makh/stat-report/${reportId}`);
}

export function sendEmail(reportId: ReportId, stat: Partial<ReportResponse>) {
  return Endpoint.post<ReportResponse>(`@makh/stat-report/send-email/${reportId}`, { data: { ...stat } });
}

export function saveStatReportForm(id: string, data: StatReportFormData, fields: FCFormDataType[], isPublic = false) {
  if (isPublic) {
    return Endpoint.post<ReportResponse>(`@makh/public/stat-report/stat-form/${id}`, { data: { data, fields } });
  }
  return Endpoint.post<ReportResponse>(`@makh/stat-report/stat-form/${id}`, { data: { data, fields } });
}

export function resendEmailToAll(batchId: string) {
  return Endpoint.post<void>(`@makh/stat-collection/report-resend-all/${batchId}`);
}

export function resendEmail(reportId: string) {
  return Endpoint.post<void>(`@makh/stat-collection/report-resend/${reportId}`);
}
